
import { Component } from 'vue-property-decorator';
import PersistentModal from '@/components/shared/modals/PersistentModal';

@Component
export default class CampusManagementNetworkHelpModal extends PersistentModal {}
